import { Configuration } from "../types";

// Production Config
export const AppSettings: Configuration = {
  apiURL: "https://webflowers.azure-api.net/ApiPortalSD/",
  apiKey: "e85814dcead849bdab1bc462efdc9d33", 
  msal: {
    clientId: "0b89c178-68e1-418a-ad2b-3108d80ed0ae",
    scopes: ["User.Read"],
    redirectUri: "https://portalsdght.azurewebsites.net",
    authority: "https://login.microsoftonline.com/510f9de0-9615-4a97-8ffa-0354dd6cd6c7",
  },
};

// Use this config for https://app-portalsociodemografico-api-test.azurewebsites.net
// export const AppSettings: Configuration = {
//   apiURL: "https://app-portalsociodemografico-api-test.azurewebsites.net",
//   msal: {
//     clientId: "d429a174-955e-4b9e-a8b1-c528291c0aa6",
//     scopes: ["User.Read"],
//     redirectUri: "http://localhost:3000",
//     authority: "https://login.microsoftonline.com/63e8f62a-1fe4-4b6e-b74a-bef036828dd7",
//   },
// };
